module.exports = __webpack_public_path__ + "static/img/uidesignmobile.15ded5c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Telll/uidesignmobile.png
// module id = +MqQ
// module chunks = 0